import { SelectableActionsDirective } from './selectable-actions.directive';

export const Directives = [
	SelectableActionsDirective,
];
